import React from "react"
import { useNavigate } from "react-router-dom"

import Icon from "@components/ui/Icon/Icon"
import Text from "@components/ui/Typography/Text"
import Chip from "@components/ui/Chip/Chip"
import { getSolutionCoverImage } from "@framework/constants/search-results"
import mainRoutes from "@root/main.routes"

import styles from "./SolutionCard.module.sass"

/**
 * Homepage card that opens Copilot Studio chat ("LabWizard (New)").
 * Sits beside the existing LabWizard solution card (old Fact Finder chat).
 */
const CopilotLandingCard: React.FC = () => {
  const navigate = useNavigate()
  const coverImage = getSolutionCoverImage("insights-finder")

  return (
    <button
      className={styles.root}
      type="button"
      onClick={() => navigate(mainRoutes.copilot())}
    >
      <div className={styles.illustrationContainer}>
        <img
          className={styles.illustration}
          src={coverImage}
          alt="LabWizard (New)"
        />
      </div>

      <div className={styles.body}>
        <div className={styles.title}>
          <div className={styles.betaContainer}>
            <Chip variant="rounded" color="green">
              New
            </Chip>
            <Text
              variant="h4"
              color="text100Color"
              weight="bold"
              title="LabWizard (New)"
            >
              LabWizard (New)
            </Text>
          </div>
        </div>

        <div className={styles.description}>
          Get insights about product technical and safety data, application
          specifications, use cases, and more with the new LabWizard Copilot
          chat.
        </div>

        <Text variant="body1" className={styles.cta}>
          Search <Icon name="arrow-up" rotateAngle={90} />
        </Text>
      </div>
    </button>
  )
}

export default CopilotLandingCard
